export const raceYear = 2026;

function createDate(monthName, day = 15) {
    const monthMap = {
        January: 0, February: 1, March: 2, April: 3,
        May: 4, June: 5, July: 6, August: 7,
        September: 8, October: 9, November: 10, December: 11,
    };
    return new Date(raceYear, monthMap[monthName], day);
}

export const upcomingRaces = [
    {
        id: 1,
        name: "Montana Gravel Challenge",
        date: "May 1-3",
        dateObj: createDate("May", 1),
        location: "Missoula, MT",
        vibe: "Speedy gravel, mudfest, who knows.",
    },
    {
        id: 2,
        name: "Tour de Bloom",
        date: "May 14-19",
        dateObj: createDate("May", 14),
        location: "Wenatchee, WA",
        vibe: "PNW to the max.",
    },
    {
        id: 4,
        name: "The Roadeo",
        date: "June 12-14",
        dateObj: createDate("June", 12),
        location: "Philipsburg, MT",
        vibe: "Big sky, big climbs.",
    },
    {
        id: 5,
        name: "The Last Best Ride",
        date: "July 26",
        dateObj: createDate("July", 26),
        location: "Whitefish, MT",
        vibe: "Lifetime Grand Prix without actually being LGP.",
    },
    {
        id: 6,
        name: "Country Cross Super Prestige",
        date: "September 2",
        dateObj: createDate("September", 14),
        location: "Huson, MT",
        vibe: "Literal backyard CX, yet still somehow UCI.",
    },
    {
        id: 7,
        name: "Rolling Thunder CX",
        date: "October",
        dateObj: createDate("October", 22),
        location: "Missoula, MT",
        vibe: "The winner gets an axe.",
    },
];
